import "./App.css";

function Paragraph() {
  return (
    <div className="paragraph1">
      <h1>सुविचार</h1>
      <div
        style={{
          height: "2px",
          width: "68%",
          backgroundColor: "white",
          margin: "10px 0",
        }}
      ></div>

      <h1>
        रेत और मिट्टी से हम कहानियों को आकार देते हैं | हर बर्तन एक कृति है, जो
        हाथों से बनी है और जुनून से तपाई गई है | स्वागत है उस दुनिया में, जहाँ
        सृजन हमारा हुनर है और हर कृति में एक अनकही कहानी बसी है |
      </h1>
    </div>
  );
}

export default Paragraph;
